import { Box, Skeleton, Stack, Typography, useTheme } from "@mui/material";
import { isString } from "lodash-es";

interface IBybSectionHeader {
  title?: string | React.ReactNode;
  subTitle?: string | null;
  children?: React.ReactNode;
}

const BybSectionHeader = ({ title, subTitle, children }: IBybSectionHeader) => {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        alignItems: "center",
      }}
    >
      <Box sx={{ marginBottom: 1 }}>
        {title ? (
          isString(title) ? (
            <Typography variant="text1xl700" color="dsBase.v200" textTransform="capitalize">
              {title}
            </Typography>
          ) : (
            title
          )
        ) : (
          <Skeleton variant="text" width={200} height={28} />
        )}
      </Box>
      {subTitle ? (
        <Typography variant="textS500" color="dsNeutral.v300" textAlign={"center"}>
          {subTitle}
        </Typography>
      ) : (
        <Skeleton variant="text" width={100} height={20} />
      )}
      {children && (
        <Box
          sx={{
            marginTop: theme.spacing(2),
            width: "100%",
          }}
        >
          {children}
        </Box>
      )}
    </Stack>
  );
};

export default BybSectionHeader;
